import Vue from 'vue';
import './plugins/vuetify';
import App from './App.vue';
import axios from 'axios';
import router from './router';
import Keycloak from 'keycloak-js';

const {
  VUE_APP_KC_CLIENT_ID: clientId,
  VUE_APP_KC_REALM: realm,
  VUE_APP_KC_URL: url
} = process.env;

Vue.config.productionTip = false;

const ALLOWED_ROLES = [
  'admin',
  'direction',
  'responsable-filiere',
  'doyen',
  'centre-formation-base',
  'heg-lang'
];

const tokenInterceptor = keycloak => {
  axios.interceptors.request.use(
    config => {
      config.headers.Authorization = `Bearer ${keycloak.token}`;
      return config;
    },
    error => Promise.reject(error)
  );
};

const keycloak = new Keycloak({ url, realm, clientId });
Vue.prototype.$keycloak = keycloak;

keycloak
  .init({
    onLoad: 'login-required',
    checkLoginIframe: false,
    pkceMethod: 'S256',
    useNonce: false // workaround for keycloak-js v21 nonce check bug
  })
  .then(authenticated => {
    if (!authenticated) {
      keycloak.login();
      return;
    }

    const hasAllowedRole = ALLOWED_ROLES.some(role =>
      keycloak.hasResourceRole(role, clientId)
    );
    if (!hasAllowedRole) {
      keycloak.logout();
      return;
    }

    tokenInterceptor(keycloak);

    new Vue({
      router,
      render: h => h(App)
    }).$mount('#app');

    // Refresh token if it expires within 30s, every 10s
    setInterval(() => {
      keycloak.updateToken(30).catch(() => keycloak.login());
    }, 10000);
  })
  .catch(err => {
    // eslint-disable-next-line no-console
    console.error('Keycloak init failed:', err);
  });
